export default function History() {
  const timeline = [
    {
      year: '2004',
      title: 'Fundação da Agubel',
      description: 'Criação da Associação Gestora da Usina de Beneficiamento de Lácteos em Sumé, Paraíba, com foco na agricultura familiar.',
      icon: 'ri-seedling-line'
    },
    {
      year: '2006',
      title: 'Registro SIF',
      description: 'Conquista do registro no Serviço de Inspeção Federal, permitindo comercialização nacional e internacional.',
      icon: 'ri-shield-check-line'
    },
    {
      year: '2012',
      title: 'Expansão de Parcerias',
      description: 'Ampliação das parcerias com associações de produtores do Cariri, beneficiando mais de 100 famílias.',
      icon: 'ri-team-line'
    },
    {
      year: '2022',
      title: 'Diversificação de Produtos',
      description: 'Lançamento de queijos condimentados com pimenta calabresa, alecrim, orégano e canela.',
      icon: 'ri-restaurant-line'
    },
    {
      year: '2023',
      title: 'Primeiras Premiações',
      description: 'Reconhecimento nacional e internacional com medalhas de ouro, prata e bronze em concursos de queijos.',
      icon: 'ri-medal-line'
    },
    {
      year: '2025',
      title: 'Nova Fase',
      description: 'Instalação de equipamentos para produção de bebidas lácteas e iogurtes, expandindo o portfólio de produtos.',
      icon: 'ri-rocket-line'
    }
  ];

  return (
    <section id="historia" className="py-8 md:py-20 bg-gradient-to-b from-green-50 to-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-6 md:mb-16">
          <h2 className="text-2xl md:text-5xl font-bold text-green-800 mb-3">Nossa História</h2>
          <div className="w-20 h-1 bg-amber-500 mx-auto mb-3 md:mb-6"></div>
          <p className="text-sm md:text-xl text-gray-700 max-w-3xl mx-auto">
            Duas décadas de dedicação à agricultura familiar e à produção de lácteos de excelência
          </p>
        </div>
        
        <div className="max-w-5xl mx-auto">
          {timeline.map((item, index) => (
            <div key={index} className="relative mb-6 md:mb-12 last:mb-0">
              <div className={`flex items-center gap-4 md:gap-8 ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                <div className={`flex-1 ${index % 2 === 0 ? 'text-right' : 'text-left'}`}>
                  <div className="bg-white p-4 md:p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
                    <h3 className="text-xl md:text-3xl font-bold text-amber-600 mb-1 md:mb-2">{item.year}</h3>
                    <h4 className="text-base md:text-xl font-bold text-green-800 mb-2 md:mb-3">{item.title}</h4>
                    <p className="text-xs md:text-base text-gray-700">{item.description}</p>
                  </div>
                </div>
                
                <div className="relative z-10">
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-br from-green-600 to-green-700 rounded-full flex items-center justify-center shadow-lg">
                    <i className={`${item.icon} text-lg md:text-2xl text-white`}></i>
                  </div>
                </div>
                
                <div className="flex-1"></div>
              </div>
              
              {index < timeline.length - 1 && (
                <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-6 md:h-12 bg-green-300 top-14 md:top-20"></div>
              )}
            </div>
          ))}
        </div>
        
        <div className="mt-8 md:mt-16 grid md:grid-cols-3 gap-4 md:gap-8 max-w-4xl mx-auto">
          <div className="bg-white p-4 md:p-6 rounded-lg shadow-md text-center">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
              <i className="ri-user-heart-line text-xl md:text-2xl text-green-600"></i>
            </div>
            <h4 className="text-xl md:text-2xl font-bold text-green-800 mb-1 md:mb-2">150+</h4>
            <p className="text-xs md:text-base text-gray-700">Famílias Beneficiadas</p>
          </div>
          
          <div className="bg-white p-4 md:p-6 rounded-lg shadow-md text-center">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
              <i className="ri-award-line text-xl md:text-2xl text-amber-600"></i>
            </div>
            <h4 className="text-xl md:text-2xl font-bold text-amber-800 mb-1 md:mb-2">20+</h4>
            <p className="text-xs md:text-base text-gray-700">Anos de Tradição</p>
          </div>
          
          <div className="bg-white p-4 md:p-6 rounded-lg shadow-md text-center">
            <div className="w-10 h-10 md:w-12 md:h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
              <i className="ri-checkbox-circle-line text-xl md:text-2xl text-green-600"></i>
            </div>
            <h4 className="text-xl md:text-2xl font-bold text-green-800 mb-1 md:mb-2">SIF</h4>
            <p className="text-xs md:text-base text-gray-700">Certificação Federal</p>
          </div>
        </div>
      </div>
    </section>
  );
}
